function order_flats_table(){

    let $table = $('.flats-table tbody');

    let order_by = $('.js-flats-table-order.active').data('order');
    let order = $('.js-flats-table-order.active').hasClass('asc') ? 'asc' : 'desc';

    let $rows = $table.find('tr').toArray().sort(function(rowA, rowB) {
        let orderA = parseInt($(rowA).data(order_by));
        let orderB = parseInt($(rowB).data(order_by));
        if(order == 'asc'){
            return orderA - orderB;
        }else{
            return orderB - orderA;
        }
    });

    // Odstránenie existujúcich riadkov z tabuľky
    $table.empty();

    // Pridanie zoradených riadkov späť do tabuľky
    $.each($rows, function(index, row) {
        $table.append(row);
    });
}

const $headerTable = $(".flats-table thead tr.fixed-header");
const $contentTable = $(".flats-table tbody");

// Nastaví šírky stĺpcov v hlavičke na základe šírok stĺpcov v tele
function setHeaderColumnWidths() {
    const $headerCells = $headerTable.find('th');
    const $contentCells = $contentTable.find('tr').first().children();

    $headerCells.each(function(index) {
        const contentCellWidth = $contentCells.eq(index).outerWidth();
        $(this).css('min-width', contentCellWidth + 'px');
    });
}

// Volaj funkciu po načítaní stránky a pri zmene veľkosti okna
setHeaderColumnWidths();
$(window).on('resize', setHeaderColumnWidths);

const $flatsTable = $('.flats-table');

function checkVisibility() {
    const windowTop = $(window).scrollTop();
    const windowBottom = windowTop + $(window).height();
    const elementTop = $flatsTable.offset().top;
    const elementBottom = elementTop + $flatsTable.outerHeight();

    if (windowTop > elementTop && windowBottom < (elementBottom + 600)) {
        $('.fixed-header', $flatsTable).addClass('active');
        $flatsTable.css('padding-top', '70px');
    } else {
        $('.fixed-header', $flatsTable).removeClass('active');
        $flatsTable.css('padding-top', 0);
    }
}

if($flatsTable.length){
    // Skontrolovať viditeľnosť pri načítaní stránky a pri scrollovaní
    checkVisibility();
    $(window).on('scroll resize', checkVisibility);
}


$('.js-flats-table-scroll').on('scroll', function() {
    $('.js-flats-table-thead-scroll .fixed-header').scrollLeft($(this).scrollLeft());
});

$('.js-flats-table-thead-scroll .fixed-header').on('scroll', function() {
    $('.js-flats-table-scroll').scrollLeft($(this).scrollLeft());
});


$(document).on('click', '.js-flats-table-order', function(){

    if($(this).hasClass('asc')){
        $(this).removeClass('asc').addClass('desc');
    }else if($(this).hasClass('desc')){
        $(this).removeClass('desc').addClass('asc');
    }else{
        $('.js-flats-table-order.active').removeClass('active desc asc');
        $(this).addClass('active').addClass('asc');
    }

    order_flats_table();
});

function set_range_filter(range_filter, type = 1){
    let value = range_filter.val();
    let formatted_value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    if(type === 1){
        if(range_filter.hasClass('range-min')){
            $('.js-flats-price-filter-value-min').text(formatted_value);
        }else{
            $('.js-flats-price-filter-value-max').text(formatted_value);
        }
    }else if(type == 2){
        if(range_filter.hasClass('range-min')){
            $('.js-flats-interior-filter-value-min').text(formatted_value);
        }else{
            $('.js-flats-interior-filter-value-max').text(formatted_value);
        }
    }else if(type == 3){
        if(range_filter.hasClass('range-min')){
            $('.js-flats-exterior-filter-value-min').text(formatted_value);
        }else{
            $('.js-flats-exterior-filter-value-max').text(formatted_value);
        }
    }
}


$('.js-flats-filter-price').on('input', function(){
    set_range_filter($(this), 1);
});

$('.js-flats-filter-interior').on('input', function(){
    set_range_filter($(this), 2);
});

$('.js-flats-filter-exterior').on('input', function(){
    set_range_filter($(this), 3);
});

$('.js-flats-filter-price, .js-flats-filter-interior, .js-flats-filter-exterior').on('change', function(){
    flat_filter();
});

$('.js-flats-filter-rooms, .js-flats-filter-floors, .js-flats-filter-blocks').on('click', function(){
    if($(this).hasClass('active')){
        $(this).removeClass('active');
    }else{
        $(this).addClass('active');
    }
    flat_filter();
});

if($('#run_filter').length){
    flat_filter();
}

const rangeInput = $('.js-price-filter-range');
if(rangeInput.length){

    const priceInput = $('.js-price-filter-input');
    const progress = $('.js-price-filter-progress');
    let priceGap = 0;

    const overlapping = (rangeInput[1].max - rangeInput[0].min) * 0.1;

    $(document).on('input', '.js-price-filter-range' ,function(){
        let minVal = parseInt(rangeInput[0].value);
        let maxVal = parseInt(rangeInput[1].value);

        if($(this).hasClass('range-min')){
            if(maxVal - minVal < overlapping ){
                $(rangeInput[0]).css('z-index', 1);
            }
        }else{
            if(maxVal - minVal < overlapping ){
                $(rangeInput[0]).css('z-index', '');
            }
        }

        if((maxVal - minVal) < priceGap){
            if($(this).hasClass('range-min')){
                rangeInput[0].value = maxVal - priceGap
            }else{
                rangeInput[1].value = minVal + priceGap;
            }
        }else{
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            let new_left = (minVal - rangeInput[0].min) / (rangeInput[1].max - rangeInput[0].min) * 100 + "%";

            let new_right = 0
            if(maxVal != rangeInput[1].max){
                new_right = 100 - ((maxVal - rangeInput[0].min ) / (parseInt(rangeInput[0].min) - rangeInput[0].max )) * 100 * -1 + '%'
            }
            progress.css('left', new_left);
            progress.css('right', new_right);

        }
    });
}

const interiorFilterInput = $('.js-interior-filter-range');
if(interiorFilterInput.length){

    const interiorInput = $('.js-interior-filter-input');
    const interiorProgress = $('.js-interior-filter-progress');
    let priceGap = 0;

    const overlapping = (interiorFilterInput[1].max - interiorFilterInput[0].min) * 0.1;

    $(document).on('input', '.js-interior-filter-range' ,function(){
        let minVal = parseInt(interiorFilterInput[0].value);
        let maxVal = parseInt(interiorFilterInput[1].value);

        if($(this).hasClass('range-min')){
            if(maxVal - minVal < overlapping ){
                $(interiorFilterInput[0]).css('z-index', 1);
            }
        }else{
            if(maxVal - minVal < overlapping ){
                $(interiorFilterInput[0]).css('z-index', '');
            }
        }

        if((maxVal - minVal) < priceGap){
            if($(this).hasClass('range-min')){
                interiorFilterInput[0].value = maxVal - priceGap
            }else{
                interiorFilterInput[1].value = minVal + priceGap;
            }
        }else{
            interiorInput[0].value = minVal;
            interiorInput[1].value = maxVal;
            let new_left = (minVal - interiorFilterInput[0].min) / (interiorFilterInput[1].max - interiorFilterInput[0].min) * 100 + "%";

            let new_right = 0
            if(maxVal != interiorFilterInput[1].max){
                new_right = 100 - ((maxVal - interiorFilterInput[0].min ) / (parseInt(interiorFilterInput[0].min) - interiorFilterInput[0].max )) * 100 * -1 + '%'
            }
            interiorProgress.css('left', new_left);
            interiorProgress.css('right', new_right);

        }
    });
}

const exteriorFilterInput = $('.js-exterior-filter-range');
if(exteriorFilterInput.length){

    const exteriorInput = $('.js-exterior-filter-input');
    const exteriorProgress = $('.js-exterior-filter-progress');
    let priceGap = 0;

    const overlapping = (exteriorFilterInput[1].max - exteriorFilterInput[0].min) * 0.1;

    $(document).on('input', '.js-exterior-filter-range' ,function(){
        let minVal = parseInt(exteriorFilterInput[0].value);
        let maxVal = parseInt(exteriorFilterInput[1].value);

        if($(this).hasClass('range-min')){
            if(maxVal - minVal < overlapping ){
                $(exteriorFilterInput[0]).css('z-index', 1);
            }
        }else{
            if(maxVal - minVal < overlapping ){
                $(exteriorFilterInput[0]).css('z-index', '');
            }
        }

        if((maxVal - minVal) < priceGap){
            if($(this).hasClass('range-min')){
                exteriorFilterInput[0].value = maxVal - priceGap
            }else{
                exteriorFilterInput[1].value = minVal + priceGap;
            }
        }else{
            exteriorInput[0].value = minVal;
            exteriorInput[1].value = maxVal;
            let new_left = (minVal - exteriorFilterInput[0].min) / (exteriorFilterInput[1].max - exteriorFilterInput[0].min) * 100 + "%";

            let new_right = 0
            if(maxVal != exteriorFilterInput[1].max){
                new_right = 100 - ((maxVal - exteriorFilterInput[0].min ) / (parseInt(exteriorFilterInput[0].min) - exteriorFilterInput[0].max )) * 100 * -1 + '%'
            }
            exteriorProgress.css('left', new_left);
            exteriorProgress.css('right', new_right);

        }
    });
}


function flat_filter(){
    let count = 0;

    let flats = $('.js-flat-row');
    let selected_rooms = [];
    let selected_floors = [];
    let selected_blocks = [];

    let selected_status = $('.js-flats-filter-status.active').data('status');

    let selected_rooms_buttons = $('.js-flats-filter-rooms.active');

    selected_rooms_buttons.each(function(){
        selected_rooms.push($(this).data('rooms'));
    });

    let selected_floors_buttons = $('.js-flats-filter-floors.active');

    selected_floors_buttons.each(function(){
        selected_floors.push($(this).data('floor'));
    });

    let selected_blocks_buttons = $('.js-flats-filter-blocks.active');

    selected_blocks_buttons.each(function(){
        selected_blocks.push($(this).data('block'));
    });

    let selected_price_from = parseInt( $('.js-price-filter-input.input-min').val() );
    let selected_price_to = parseInt( $('.js-price-filter-input.input-max').val() );

    let selected_interior_from = parseInt( $('.js-interior-filter-input.input-min').val() );
    let selected_interior_to = parseInt( $('.js-interior-filter-input.input-max').val() );

    let selected_exterior_from = parseInt( $('.js-exterior-filter-input.input-min').val() );
    let selected_exterior_to = parseInt( $('.js-exterior-filter-input.input-max').val() );

    flats.each(function(){
        let flat = $(this);
        let flat_floor = flat.data('floor');
        let flat_rooms = flat.data('rooms');
        let flat_block = flat.data('block');
        let flat_price = flat.data('price');
        let flat_interior = flat.data('interior');
        let flat_exterior = flat.data('exterior');
        let flat_status = flat.data('status');

        if(
            (!selected_floors.length || jQuery.inArray(flat_floor, selected_floors) !== -1)
            && (!selected_rooms.length || jQuery.inArray(flat_rooms, selected_rooms) !== -1)
            && (!selected_blocks.length || jQuery.inArray(flat_block, selected_blocks) !== -1)
            && (!flat_price || (
                (selected_price_from <= flat_price)
                && (selected_price_to >= flat_price)
            ))
            && (!flat_interior || (
                (selected_interior_from <= flat_interior)
                && (selected_interior_to >= flat_interior)
            ))
            && (!flat_exterior || (
                (selected_exterior_from <= flat_exterior)
                && (selected_exterior_to >= flat_exterior)
            ))
            && (!selected_status || selected_status === flat_status)
        ){
            flat.show();
            count++;
        }else{
            flat.hide();
        }
    });

    order_flats_table();

    if(count === 0){
        $('.js-flats-filter-empty').show();
    }else{
        $('.js-flats-filter-empty').hide();
    }
}

$(document).on('click', '.js-flats-filter-status:not(.active)', function(){
    $('.js-flats-filter-status.active').removeClass('active');
    $(this).addClass('active');
    flat_filter();
})

$('.js-reset-filters').click(function(){

    $('.js-flats-filter-rooms, .js-flats-filter-floors, .js-flats-filter-blocks').removeClass('active');
    $('.custom-select-tab > div[data-value="0"]').click();

    $('.js-flats-filter-form').trigger('reset');

    set_range_filter($('.js-flats-filter-price.range-min'));
    set_range_filter($('.js-flats-filter-price.range-max'));
    set_range_filter($('.js-flats-filter-interior.range-min'), 2);
    set_range_filter($('.js-flats-filter-interior.range-max'), 2);
    $('.js-price-filter-progress').css('left', '0').css('right', '0');
    $('.js-interior-filter-progress').css('left', '0').css('right', '0');

    flat_filter();
})
